import React from "react";

const Level3Popup = ({
  isOpen,
  onCancel,
  onNo,
  onYes,
  onPickMine,
  selectedLanguage
}) => {
  if (!isOpen) return null;

  return (
    <div className="modalCus" id="myModal" style={{ zIndex: 1056 }}>
      <div className="modal-dialog modal-dialog-centered width600">
        <div className="modal-content">
          <div className="d-flex justify-content-center">
            <h4 className="mb-0 fw-bold font-20" htmlFor="">
              <span
                className="material-icons top3 "
                style={{
                  fontSize: "400%",
                  color: "#3fa247",
                  marginTop: "25px",
                }}>
                info
              </span>
            </h4>
            <button
              type="button"
              className="btn btn-outline-danger level3close modalclose download "
              onClick={(e) => onCancel(e)}>
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>
          <div className="font-18 infoBody">
            {
              selectedLanguage.LstLanguageCodes
                .UI_ChangingAccessControlLimitReaders
            }
          </div>
          <div className="font-18 infoBody" style={{ textAlign: "center" }}>
            {selectedLanguage.LstLanguageCodes.UI_DoYouWishToAdd}
          </div>

          <div className="pb-4 px-4 mt-4 d-flex flex-wrap justify-content-between">
            <button
              type="button"
              title={selectedLanguage.LstLanguageCodes.UI_No}
              className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
              data-bs-dismiss="modal"
              onClick={(e) => onNo()}>
              {selectedLanguage.LstLanguageCodes.UI_No}
            </button>
            <button
              type="button"
              title={selectedLanguage.LstLanguageCodes.UI_Yes}
              className="btn btn-primary px-2 ms-1 w-140p truncate"
              onClick={(e) => onYes()}>
              {selectedLanguage.LstLanguageCodes.UI_Yes}
            </button>
            <button
              type="button"
              className="btn btn-outline-success px-1em"
              style={{ marginLeft: "10px", padding: "0.56rem 0.8rem" }}
              data-bs-dismiss="modal"
              title={selectedLanguage.LstLanguageCodes.UI_IWillPickMine}
              onClick={(e) => onPickMine()}>
              {selectedLanguage.LstLanguageCodes.UI_IWillPickMine}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Level3Popup;
